<h3 mat-dialog-title class="color-primary">{{ data.title }}</h3>
<div class="mb-20">
	{{title}}
</div>
<div mat-dialog-content class="dialog-content">
	<app-custom-tile-view #customtileview *ngIf="data.data && data.data['_id']" [isAdmin]="data.isAdmin"
		[isSuperAdmin]="data.isSuperAdmin" [tileId]="data.data['_id']" [readonly]="readonly"
		(returnTitle)="setTitle($event)" (returnAction)="setAction($event)">
	</app-custom-tile-view>
</div>
<div mat-dialog-actions class="dialog-actions">
	<div style="width: 100%;margin-top:10px;">
		<button mat-flat-button color="danger" (click)="closeModal(undefined)">{{'Close' }}</button>
		<button mat-flat-button *ngIf="readonly" (click)="submitData()" [disabled]="loading">{{'Submit Readonly'
			}}</button>
		<button *ngIf="!readonly" mat-flat-button (click)="submitData()" [disabled]="loading">{{'Submit'}}</button>
	</div>
</div>